<template>
  <div class="privacy-policy p-4">
    <h1>Privacy Policy</h1>
    <p>We value your privacy and are committed to protecting your personal information.</p>

    <h2>Information We Collect</h2>
    <p>We collect your name, email, and course activity data when you use our service.</p>

    <h2>How We Use Information</h2>
    <p>Your data is used to improve our service and personalize your learning experience.</p>

    <h2>Third-party Sharing</h2>
    <p>We may share information with trusted partners like authentication providers (e.g. Google, Facebook).</p>

    <h2>Your Rights</h2>
    <p>You can request deletion or correction of your data at any time.</p>

    <h2>Contact</h2>
    <p>If you have any questions, please contact johnslanguage@gmail.com.</p>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy"
};
</script>

<style scoped>
.privacy-policy {
  max-width: 800px;
  margin: auto;
}
</style>

